import React from "react";

import { Document } from "@react-pdf/renderer";

import { generateQuoteDocument } from "../pdf-documents/DocumentForQuote";
import { generateOrderDocument } from "../pdf-documents/DocumentForOrder";

const PDFDocument = ({ data, id, expDate = "", option = "quote" }) => {
  const selectOption = (option) => {
    switch (option) {
      case "quote":
        return generateQuoteDocument(data, id, expDate);
      case "order":
        return generateOrderDocument(data, id);
      default:
        return generateQuoteDocument(data, id, expDate);
    }
  };

  return <Document>{selectOption(option)}</Document>;
};

export default PDFDocument;
